<div class='flex flex-col' *ngIf='(options$ | async) as options' >
  <label>{{label}}</label>
  <mat-form-field floatLabel='never'>
    <mat-select [value]='_value' (selectionChange)='onChanged($event.value)' placeholder='{{label}}'>
      <mat-option *ngFor='let option of options' [value]='option.value'>{{option.label}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
